export default __webpack_public_path__ + "static/media/facebook 1.14e31d14.svg";